import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
// links that appear in navbar - they are separated from this component (navbar) so that we can redner them on responsive in sidebar as well
import HeaderLinks from "./HeaderLinks.jsx";
import companyRoutes from "../../routes/company";

class Header extends Component {
  constructor(props) {
    super(props);
    this.handleMinimizeSidebar = this.handleMinimizeSidebar.bind(this);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
  }
  makeBrand() {
    var name;
    companyRoutes.map((prop, key) => {
      const { pathname } = this.props.location;
      if (prop.redirect) {
        if (prop.path === pathname) {
          name = prop.name;
        }
      } else {
        if (prop.path === pathname) {
          name = prop.name;
        }
      }
      return null;
    });
    return name;
  }

  handleMinimizeSidebar() {
    document.body.classList.toggle("sidebar-mini");
  }

  mobileSidebarToggle(e) {
    document.documentElement.classList.toggle("nav-open");
  }
  render() {
    return (
      <Navbar fluid>
        <div className="navbar-minimize">
          <button
            id="minimizeSidebar"
            className="btn btn-default btn-fill btn-round btn-icon"
            onClick={this.handleMinimizeSidebar}
          >
            <i className="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
            <i className="fa fa-navicon visible-on-sidebar-mini"></i>
          </button>
        </div>
        <Navbar.Header>
          <Navbar.Brand>
            <a>{this.makeBrand()}</a>
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>
        {window.innerWidth > 992 ? (
          <Navbar.Collapse>
            <HeaderLinks />
          </Navbar.Collapse>
        ) : null}
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/CompanyHeader.jsx